<template>
  <div>
    <router-link
      class="chart-type-link"
      :class="{ 'router-link-exact-active': chartType.routeName === $route.name }"
      :to="getRoute($route, chartType.routeName)"
    >
      {{ chartType.displayName }}
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectorMixin from '@/mixins/SelectorMixin'

export default {
  name: 'ChartTypeSelector',
  mixins: [SelectorMixin],
  props: {
    chartType: Object,
  },
  computed: {
    ...mapState({
      geoCategories: (state) => state.ChartCategory.geoCategories,
      defaultLatitude: (state) => state.ChartCategory.defaultLatitude,
      defaultLongitude: (state) => state.ChartCategory.defaultLongitude,
      wordCloudColumns: (state) => state.ChartCategory.wordCloudColumns,
    }),
  },
  methods: {
    getRoute(route, routeName) {
      const newRoute = {
        name: routeName,
        query: {
          ...route.query,
        },
      }
      if (!this.isSeriesSelectorVisible(routeName)) {
        newRoute.query.selectedSeries = ''
        newRoute.query.serieslevel = ''
      }
      if (this.isGeoSelectorVisible(routeName) && !this.containsSelectableGeoCategories()) {
        newRoute.query.measures = ['count()']
      }
      if (this.isMeasureSingleSelectorVisible(routeName)) {
        newRoute.query.measures = ['count()']
      }
      if (this.isWordCloudKeywordSelectorVisible(routeName, this.wordCloudColumns)) {
        newRoute.query.wordCloudColumn = this.wordCloudColumns[0].attributePath
        newRoute.query.limit = this.wordCloudColumns[0].subOptions[0].attributeValue
      }
      return newRoute
    },
  },
}
</script>
